// mega menus functionality for desktop and mobile
export function megaMenuInit()
{
    /**
     * DESKTOP
     */
    // add a mouseover event listener to all elements with the class "has-mega-menu"
    // when the mouseover event is triggered, hide all mega menus
    // then show the mega menu that is a child of the element that triggered the event
    const elementsWithMegaMenu = document.querySelectorAll('.has-mega-menu');
    elementsWithMegaMenu.forEach(function (element) {
        element.addEventListener('mouseover', function () {

            const allMegaMenus = document.querySelectorAll('.mega-menu');
            allMegaMenus.forEach(function (megaMenu) {
                megaMenu.classList.add('hidden');
            });

            const megaMenuElement = element.querySelector('.mega-menu');

            if (megaMenuElement) {
                megaMenuElement.classList.add('block');
                megaMenuElement.classList.remove('hidden');
            }
        });
    });

    // also have a mouseenter for menu items that dont have a .has-mega-menu class to close mega menus
    const menuItems = document.querySelectorAll('.menu-item:not(.has-mega-menu)');
    menuItems.forEach(function (menuItem) {
        menuItem.addEventListener('mouseenter', function () {
            const allMegaMenus = document.querySelectorAll('.mega-menu');
            allMegaMenus.forEach(function (megaMenu) {
                megaMenu.classList.add('hidden');
            });
        });
    });

    // add a mouseOut event listener to all sections with class "mega-menu" that closes the mega menu
    const megaMenus = document.querySelectorAll('.mega-menu');
    megaMenus.forEach(function (megaMenu) {
        megaMenu.addEventListener('mouseout', function () {
            megaMenu.classList.add('hidden');

            // also remove the indicator
            const indicator = document.querySelector('.menu-indicator');
            indicator.style.width = '0px';
        });
    });

    // close mega menu buttons
    // add a click event listener to all elements with the class "close-mega-menu"
    // when the click event is triggered, hide all mega menus
    const closeMegaMenuButtons = document.querySelectorAll('.close-mega-menu');
    closeMegaMenuButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            const allMegaMenus = document.querySelectorAll('.mega-menu');
            allMegaMenus.forEach(function (megaMenu) {
                megaMenu.classList.add('hidden');
            });
        });
    });


    /**
     * MOBILE
     */

    // for the mobile version we'll use the class 'has-sub-menu' rather than 'has-mega-menu'

    // get all has-sub-menu elements
    const hasSubMenuElements = document.querySelectorAll('.has-sub-menu');
    
    // loop through each has-sub-menu element add an event listener to the open-sub-menu button that
    // adds the class 'menu-open' to the .sub-menu element in the hasSubMenuElement for the button that was clicked
    hasSubMenuElements.forEach(function (hasSubMenuElement) {
        const openSubMenuButton = hasSubMenuElement.querySelector('.open-sub-menu');
        openSubMenuButton.addEventListener('click', function (event) {
            const subMenu = hasSubMenuElement.querySelector('.sub-menu');
            subMenu.classList.add('menu-open');
        });
    });

    // back buttons
    const previousMenuButtons = document.querySelectorAll('.previous-menu');
    previousMenuButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            const subMenu = button.parentElement;
            subMenu.classList.remove('menu-open');
        });
    });

    // set the mobile menu to visible - we need it hidden initially to remove the initial flash of content but
    // once the page has loaded we can set it to visible as its offscreen
    const mobileMenu = document.getElementById('mobile-menu');
    mobileMenu.classList.remove('hidden');

    // adjust the height of the mobile menu to the height of the window minus the height of the masthead
    // and set the margin-top to -100vh - the height of the masthead
    function setMobileMenuHeight()
    {
        const mastheadHeight = document.getElementById('masthead').offsetHeight;
        mobileMenu.style.height = `calc(100vh)`;
    }

    // set the margin-top of the mobile menu to 100vh - the height of the masthead or to a passed in value
    function setMobileMenuMarginTop(marginTop = null)
    {
        const mastheadHeight = document.getElementById('masthead').offsetHeight;
        mobileMenu.style.marginTop = marginTop ? marginTop : `calc(-100vh - ${mastheadHeight}px`;
    }

    // inialise the mobile menu height and margin-top
    setMobileMenuHeight();
    setMobileMenuMarginTop();

    // when the element with id 'open-mobile-menu' is clicked. If the masthead has the class 'mobile-menu-open' then set the margin-top to 0
    // otherwise set the margin-top to -100vh - the height of the masthead
    // this essentially animates the menu from under the masthead into view
    const toggleMobileMenuButton = document.getElementById('toggle-mobile-menu');
    toggleMobileMenuButton.addEventListener('click', function () {
        const masthead = document.getElementById('masthead');
        if (masthead.classList.contains('mobile-menu-open')) {
            masthead.classList.remove('mobile-menu-open');
            setMobileMenuMarginTop();
        } else {
            masthead.classList.add('mobile-menu-open');
            setMobileMenuMarginTop('0');
        }
    });
}